<style lang="scss">
  @import '../resources/scss/banner.scss';
</style>

<script lang="ts">
  import { onDestroy } from 'svelte'
  import { locale } from 'svelte-i18n'
  import type { Slugs } from '../config/slugs'
  import { listBanners } from '../controllers/AppController'
  import { banners } from '../stores/stores'
  import DonationContactBtn from './Donation_Contact_Btn.svelte'
  import LibraryButton from './Library_Button.svelte'
  import { createEventDispatcher } from 'svelte'

  export let slug: Slugs
  let lang = $locale!
  const dispatch = createEventDispatcher()

  const unsubscribe = locale.subscribe(() => {
    lang = $locale!
  })
  function myClick() {
    setTimeout(function () {
      document.getElementById('indicator0')?.click()
    }, 5000)
  }
  myClick()
  void listBanners(lang, slug).then(() => {
    dispatch('bannerLoaded')
  })
  onDestroy(unsubscribe)
</script>

{#if $banners.length > 0}
  <section class="banner position-relative">
    <div class="container-fluid px-0">
      <div
        id="carouselExampleIndicators"
        class="carousel slide"
        data-bs-ride="carousel"
        data-bs-interval="5000"
      >
        {#if $banners.length > 1}
          <div class="carousel-indicators">
            <ul class="carousel-indicators hero-carousel-indicators">
              {#each $banners as b, i}
                <li
                  data-bs-target="#carouselExampleIndicators"
                  data-bs-slide-to={i}
                  class="d-flex indicator justify-content-center align-items-center {i ===
                  0
                    ? 'active'
                    : ''}"
                  id="indicator{i}"
                  aria-current="true"
                  aria-label={`Slide ${i}`}
                >
                  <div id="indicator-inside-circle" />
                </li>
              {/each}
            </ul>
          </div>
        {/if}
        <div class="carousel-inner">
          {#each $banners as b, i}
            {#if b.show_button}
              <LibraryButton />
            {/if}
            <div class="carousel-item {i === 0 ? 'active' : ''}">
              <div
                class="carousel-bg-image w-100 d-none d-md-block  {b.vertical_position_desktop} {b.horizontal_position_desktop} "
                style="background-image: url('{b.desktop_image?.fullUrl}')"
              />
              <div
                class="carousel-bg-image w-100 d-block d-md-none {b.vertical_position_mobile} {b.horizontal_position_mobile} "
                style="background-image: url('{b.mobile_image?.fullUrl}')"
              />
              <div class="carousel-caption h-100 container-xxl py-0">
                {#if b.only_title}
                  <div class="row h-100 position-relative">
                    <div class="col-12">
                      <div
                        class="banner carousel-title text-start position-absolute only-title"
                      >
                        {@html b.translations[0]?.title}
                      </div>
                    </div>
                  </div>
                {:else}
                  <div class="row pb-4 title-row">
                    <div class="col-5">
                      <div class="banner carousel-title text-start">
                        {@html b.translations[0]?.title}
                      </div>
                    </div>
                  </div>
                  <div class="row description">
                    <div class="col-10 col-md-7">
                      <h4 class="description text-start">
                        {b.translations[0]?.description}
                      </h4>
                    </div>
                  </div>
                  <div class="row contact-donate">
                    <div class="col col-md-8">
                      <DonationContactBtn />
                    </div>
                  </div>
                {/if}
              </div>
            </div>
          {/each}
        </div>
      </div>
    </div>
  </section>
{/if}
